import { WavyDivider } from '../components/Decorations';
import { Reveal } from '../components/Reveal';
import { Accent, SectionHeading } from '../components/SectionHeading';
import { visibleTestimonials } from '../content/testimonials';

export function Testimonials() {
  // Empty in a production build until real quotes replace the placeholders.
  if (visibleTestimonials.length === 0) return null;

  return (
    <>
      <WavyDivider className="-mb-px text-blush-50" flip />
      <section className="bg-blush-50 px-6 py-20 sm:px-8 sm:py-24">
        <div className="mx-auto max-w-6xl">
          <Reveal>
            <SectionHeading eyebrow="Kind words">
              What families <Accent>say</Accent>.
            </SectionHeading>
          </Reveal>

          <ul className="mt-14 grid gap-6 lg:grid-cols-3">
            {visibleTestimonials.map((testimonial, index) => (
              <Reveal key={testimonial.attribution + index} delay={index * 110} as="li">
                <figure className="relative h-full rounded-blob bg-white p-8 shadow-petal">
                  {testimonial.isPlaceholder && (
                    <span className="absolute -top-3 left-6 rounded-full bg-sun px-3 py-1 font-display text-xs font-bold tracking-wide text-ink uppercase">
                      Placeholder
                    </span>
                  )}
                  <blockquote className="leading-relaxed">
                    &ldquo;{testimonial.quote}&rdquo;
                  </blockquote>
                  <figcaption className="mt-6 font-display text-sm font-semibold text-mint-800">
                    {testimonial.attribution}
                    {testimonial.detail && (
                      <span className="block font-sans font-normal text-muted">
                        {testimonial.detail}
                      </span>
                    )}
                  </figcaption>
                </figure>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>
      <WavyDivider className="-mt-px text-blush-50" />
    </>
  );
}
